export const checkPasswordCriteria = (password) => {
  return {
    minLength: password.length >= 8,
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
    hasNumber: /[0-9]/.test(password),
    hasSpecialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password),
  };
};

export const isPasswordValid = (password) => {
  const criteria = checkPasswordCriteria(password);
  return Object.values(criteria).every(Boolean);
};
